
<div class="d-flex align-items-center justify-content-between bg-white">
  <div>
    <img src="../../../assets/img/image.png" style="height: 230px" alt="">
  </div>
  <div class="d-flex align-items-center flex-column" style="width: 100%" >
    <div class="mb-3">
      <i class="fa fa-refresh fa-spin" style="font-size: 32px;"> </i>
    </div>
    <div class="d-flex flex-column align-items-center">
      <p class="mb-1" style="font-family: 'Muli', sans-serif; font-size: 28px; font-weight: 800;line-height: 1;">{{item.action === 'sync' ? 'Verificando' : 'Conectando'}}</p>
      <p class="mb-0" style="font-family: 'Muli', sans-serif; font-size: 16px; font-weight: 800;line-height: 1">{{item.action === 'sync' ? 'Disponibilidad' : 'Reserva'}}</p>
    </div>
  </div>
</div>
